import React from 'react';
import Navbar from '../Header/Navbar/Navbar';
import project1 from './../../../Images/project1.png'
import project2 from './../../../Images/project2.png'
import project3 from './../../../Images/project3.png'
import daily from './../../../Images/daily.png'
import service from './../../../Images/service.png'
import ride from './../../../Images/ride.png'
const LatestProject = () => {
    return (
        <div className="container">
            <Navbar></Navbar>
            <div className="row mt-5">
                <h3 className=""><span style={{ borderBottom: '3px solid green' }}>LATEST PROJECT</span></h3>
                <div className="col-md-6 mt-3">
                    <img src={service} className="img-fluid" alt="" />
                    <div className="justify-content-center align-content-center d-flex mt-3">
                        <a href="https://service-ff551.web.app/"><div className="btn btn-primary text-center">Live Link</div></a>
                    </div>
                </div>
                <div className="col-md-6 mt-3 ">
                    <div className="ms-5">
                        <h4>Project Overview</h4>
                        <h6>It's Painting Service Type Website</h6>
                        <ol>
                            <li>It's completely a MERN project.</li>
                            <li>In this project we using separate roll for admin & user.</li>
                            <li>Admin can change order status.</li>
                            <li>User can purchase any service & see this order on Dashboard.</li>
                            <li>User can write review about service.</li>
                            <li>Using Payment Option.</li>
                        </ol>
                        <div>
                            Using Framework & Tools:<br />
                            <p align="left" className="mt-3"> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg" alt="html5" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg" alt="css3" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg" alt="bootstrap" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg" alt="javascript" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg" alt="react" width="40" height="40" />
                                <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg" alt="nodejs" width="40" height="40" /> <img src="https://vegibit.com/wp-content/uploads/2018/05/expressjs.png" alt="express js" width="90" height="40" />


                                <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg" alt="mongodb" width="40" height="40" />



                                <img src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" alt="firebase" width="40" height="40" /> <img src="https://www.vectorlogo.zone/logos/heroku/heroku-icon.svg" alt="heroku" width="40" height="40" /> </p>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mt-3">
                    <img src={daily} className="img-fluid" alt="" />
                    <div className="justify-content-center align-content-center d-flex mt-3">
                        <a href="https://gems-of-riders.web.app/"><div className="btn btn-primary text-center">Live Link</div></a>
                    </div>
                </div>
                <div className="col-md-6 mt-3">
                    <div className="ms-5">
                        <h4>Project Overview</h4>
                        <h6>It's a Grocery type Website</h6>
                        <ol>
                            <li>It's completely a MERN project.</li>
                            <li>In this project Ever one can add product.</li>
                            <li>Any one can buy product.</li>
                            <li>Specific Product Details.</li>
                            <li>User can purchase any item & see this order on Dashboard.</li>
                            <li>User Can see total orders & total amount.</li>
                            <li>Specific User Info.</li>
                        </ol>
                        <div>
                            Using Framework & Tools:<br />
                            <p align="left" className="mt-3"> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg" alt="html5" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg" alt="css3" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg" alt="bootstrap" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg" alt="javascript" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg" alt="react" width="40" height="40" />
                                <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg" alt="nodejs" width="40" height="40" /> <img src="https://vegibit.com/wp-content/uploads/2018/05/expressjs.png" alt="express js" width="90" height="40" />


                                <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg" alt="mongodb" width="40" height="40" />



                                <img src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" alt="firebase" width="40" height="40" /> <img src="https://www.vectorlogo.zone/logos/heroku/heroku-icon.svg" alt="heroku" width="40" height="40" /> </p>
                        </div>
                    </div>
                </div>


                <div className="col-md-6 mt-3">
                    <img src={ride} className="img-fluid" alt="" />
                    <div className="justify-content-center align-content-center d-flex mt-3">
                        <a href="https://daily-needs-f3d44.web.app/"><div className="btn btn-primary text-center">Live Link</div></a>
                    </div>
                </div>
                <div className="col-md-6 mt-3">
                    <div className="ms-5">
                        <h4>Project Overview</h4>
                        <h6>It's a Ride sharing type Website(Gems of riders)</h6>
                        <ol>
                            <li>It's completely a React project.</li>
                            <li>.In this project Every one go destination with ride</li>
                            <li>Using SignIn & SignUp system.</li>
                            <li>.Google Authentication System.</li>
                            <li>.User can see their destination.</li>
                            <li>Using Google Maps.</li>
                         
                        </ol>
                        <div>
                            Using Framework & Tools:<br />
                            <p align="left" className="mt-3"> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg" alt="html5" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg" alt="css3" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg" alt="bootstrap" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg" alt="javascript" width="40" height="40" /> <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg" alt="react" width="40" height="40" /></p>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default LatestProject;